<template>
  <div class="lesson-card">
    <div class="lesson-card-inner">
      <div class="lesson-card-header">
        <div class="lesson-card-title">
          {{ $t(`current_lesson`) }}
          <span class="lesson-card-time">
            🕒 <countup :start="start"></countup>
          </span>
        </div>

        <div class="lesson-card-info">
          <div class="display-flex flex-column">
            <!-- <span class="lesson-card-language-name">
              Language: English
            </span> -->
            <span class="lesson-card-lesson-level">
              {{ `${$t(`level`)}: Lite` }}
            </span>
          </div>

          <f7-button
            fill
            class="gradient"
            round
            @click="$emit('finish-lesson')"
          >
            {{ $t(`cancel`) }}
          </f7-button>
        </div>

        <!-- <f7-button @click="onJoin">onJoin</f7-button>
        <f7-button @click="onLeave">onLeave</f7-button> -->
      </div>
    </div>

    <div v-if="lesson && lesson.video" class="lesson-card-video-chat">
      <div class="lesson-card-video-chat-inner">
        <div class="lesson-card-video-chat-viewer">
          <vue-webrtc
            ref="webrtc"
            width="100%"
            :socket-u-r-l="socketURL"
            :room-id="roomId"
            :camera-height="270"
          />
          <f7-block v-if="!videoLoad" class="lesson-card-video-chat-preloader">
            <f7-preloader></f7-preloader>
          </f7-block>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Countup from '@/components/Countup.vue';

export default {
  name: 'LessonCard',

  components: {
    Countup
  },

  props: {
    start: {
      type: [String, Date],
      default: new Date()
    },

    socketURL: {
      type: String,
      required: true
    },

    lesson: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      roomId: '',
      videoLesson: false,
      videoLoad: false
    };
  },

  created() {
    if (this.lesson && this.lesson.video) {
      this.roomId = btoa(`reallang_stream_${this.lesson.id}`);
      this.videoLesson = this.lesson.video;

      setTimeout(() => {
        this.onJoin();
        this.videoLoad = true;
      }, 6000);
    }

    this.$store.subscribe(async (mutation) => {
      switch (mutation.type) {
        case 'lesson/FINISH_LESSON': {
          if (this.videoLesson) {
            this.onLeave();
          }
          break;
        }
      }
    });
  },

  methods: {
    onJoin() {
      this.$refs.webrtc.join();
    },

    onLeave() {
      this.$refs.webrtc.leave();
    }
  }
};
</script>

<style lang="less">
.lesson-card-inner {
  display: flex;
  min-height: 110px;
  flex-direction: column;
  padding: 20px 30px;
  height: 100%;
  box-sizing: border-box;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 100%;
    top: 0;
    left: 0;
    background-color: var(--f7-color-blue);
  }
}

.lesson-card-header {
  display: flex;
  flex-direction: column;
}

.lesson-card-title {
  display: flex;
  // align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  color: #252525;
}

.lesson-card-time {
  font-size: 30px;
  font-weight: 700;
  user-select: none;
  display: flex;
  align-items: center;

  .countup {
    margin-left: 5px;
  }
}

.lesson-card-info {
  display: flex;
  align-items: center;
  justify-content: space-between;

  --f7-button-min-width: 120px;
}

.lesson-card-video-chat {
  position: relative;
  height: 100%;
  width: 100%;
  max-width: calc(16 / 9 * 100vh);
}

.lesson-card-video-chat-inner {
  padding-bottom: 56.25%;
  position: relative;
}

.lesson-card-video-chat-viewer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(90deg, #ff8376 0%, #ff6089 100%);

  .video-item {
    width: 100% !important;
    transition: all 0.3s ease-in !important;

    &:not(:last-of-type) {
      position: absolute !important;
      top: 0 !important;
      right: 0 !important;
      width: 85px !important;
      height: 47.8px !important;

      video {
        height: auto;
      }
    }

    video {
      display: block;
      width: 100%;
    }
  }
}

.lesson-card-video-chat-status {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 55px;
  height: 25px;
  border-radius: 25px;
  background: #000000;
  z-index: 1;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  padding: 0 8px;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-end;
  line-height: 1;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 8px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: translate(0, -50%);
    background-color: var(--f7-color-green);
  }
}

.lesson-card-video-chat-preloader {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  padding: 0;
  transform: translate(-50%, -50%);
}
</style>
